
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Returns an x-axis translation transform.
*
* @private
* @param {string} orient - axis orientation
* @param {number} height - graph height
* @returns {string} transform
*/
function xAxisTransform( orient, height ) {
	if ( orient === 'top' ) {
		return 'translate(0,0)';
	}
	return 'translate(0,'+height+')';
}


// EXPORTS //
export default xAxisTransform;
